import API from './API';
import MediaActions from 'actions/MediaActions';
import {browserHistory} from 'react-router';
import URLSearchParams from 'url-search-params';

const MediaSource = {
  getRemoteMediaList: {
    remote(state) {
      let sendData = {
        continent_id: state.continent_id,
        country_id: state.country_id,
        state_id: state.state_id,
        city_id: state.city_id,
        category_id: state.category_id,
        first: state.first,
        maxCount: state.maxCount
      };
      let searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]) {
          searchParams.append(k, sendData[k]);
        }
      }
      return fetch(`${API.getMediaList}&${searchParams}`).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateMediaList';
        return json;
      });
    },
    shouldFetch() {
      return true;
    },
    success: MediaActions.fetchSuccess,
    error: MediaActions.fetchFailed
  },
  getRemoteMedia: {
    remote(state) {
      let url = API.getMediaDetail.replace(':id', state.id);
      return fetch(url).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateMedia';
        return json;
      });
    },
    // local(state) {
    //   return state.medias[state.id] ? state.medias : null;
    // },
    shouldFetch(state) {
      if(state.id) {
        return true;
      }
    },
    // here we setup some actions to handle our response
    // loading: SearchActions.loadingResults, // (optional)
    success: MediaActions.fetchSuccess,
    error: MediaActions.fetchFailed
  },
  getRemoteCategories: {
    remote() {
      let url = `${API.getCategoryList}`;
      return fetch(url).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateCategories';
        return json;
      });
    },
    local(state) {
      return state.categoryList.length > 0 ? state.categoryList : [];
    },
    shouldFetch(state) {
      if(state.categoryList.length === 0) {
        return true;
      } else {
        return false;
      }
    },
    success: MediaActions.fetchSuccess,
    error: MediaActions.fetchFailed
  },
  postRemoteMedia: {
    remote(state) {
      let param = {
          method: 'POST',
          body: JSON.stringify(state.postMedia),
          headers: API.jsonHeader
      };
      return fetch(API.postMedia, param).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateMedia';
        return json;
      });
    },
    shouldFetch(state) {
      if(state.postMedia.accessToken) {
        return true;
      } else {
        browserHistory.push('/login');
        return false;
      }
    },
    success: MediaActions.postMediaSuccess,
    error: MediaActions.fetchFailed
  },
  deleteRemoteMedia: {
    remote(state){
      let param = {
        method: 'POST',
        body: JSON.stringify({media_id:state.id}),
        headers: API.jsonHeader
      }; 
      return fetch(API.deleteMedia, param).then(res=>res.json()).then(json=>{
        json.updateFnName = 'deleteMedia';
        return json;
      });
    },
    shouldFetch(state) {
      return true; 
    },
    success: MediaActions.deleteMediaSuccess,
    error: MediaActions.fetchFailed
  }
};

export default MediaSource;


// WEBPACK FOOTER //
// ./src/sources/MediaSource.js